import React from 'react';

/**
 * A generic modal for showing simple messages to the user.
 * @param {string} title - The title to display in the modal header.
 * @param {string} message - The message content to display in the modal body.
 * @param {function} onClose - The function to call when the close button is clicked.
 */
export default function GenericModal({ title, message, onClose }) {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl p-8 w-full max-w-md text-center">
                <h2 className="text-xl font-bold text-[#213368] mb-4">{title}</h2>
                <p className="text-gray-600 mb-6">{message}</p>
                <button 
                    onClick={onClose} 
                    className="px-6 py-2 bg-[#20BEC6] text-white font-medium rounded-lg shadow-md hover:bg-opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#20BEC6]"
                >
                    Close
                </button>
            </div>
        </div>
    );
}
